import { request } from './request'

export const getProductsByConditions = (data) => {
  const url = '/ocean/api/v1/products/conditions'
  return request({
    method: 'POST',
    url: url,
    data: data
  })
}

// 商品导入
export const productsUpload = (data) => {
  const url = '/ocean/api/v1/product/import/products'
  return request({
    method: 'post',
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
    },
    url: url,
    data
  })
}
// 导入日志
export const getImportLogList = (params) => {
  const url = '/ocean/api/v1/product/get/import/list'
  return request({
    method: 'get',
    url: url,
    params
  })
}

export const getProductsByTitle = (params) => {
  const url = '/ocean/api/v1/products'
  return request({
    method: 'get',
    url: url,
    params: params
  })
}

export const getProductTypes = () => {
  const url = '/ocean/api/v1/products/types'
  return request({
    method: 'get',
    url: url,
  })
}

export const getProductTags = () => {
  const url = '/ocean/api/v1/products/tags'
  return request({
    method: 'get',
    url: url,
  })
}

export const getProductList = (searchData) => {
  const url = '/ocean/api/v1/products/manage/list'
  return request({
    method: 'post',
    url,
    data: searchData
  })
}

export const getProductDetail = (id) => {
  const url = `/ocean/api/v1/products/manage/detail/${id}`
  return request({
    method: 'get',
    url,
  })
}

export const getProductHistoryImages = (productId, params) => {
  const url = `/ocean/api/v1/products/manage/${productId}/historyImgs`
  return request({
    method: 'get',
    url,
    params
  })
}

/**
 * 插入商品历史图片接口
 * @param {插入字段} data
 */
export const insetProductImage = (productId, data) => {
  const url = `/ocean/api/v1/products/manage/${productId}/insertHistoryImg`
  return request({
    method: 'post',
    url,
    data
  })
}

/**
 * 新建或更新商品接口
 * @param {新建或更新字段} data
 */
export const saveProduct = (data) => {
  const url = '/ocean/api/v1/products/manage/save'
  return request({
    method: 'post',
    url,
    data
  })
}

/**
 * 批量新增商品标签
 * @param {新建或更新字段} data
 */
export const mutiAddTags = (data) => {
  const url = '/ocean/api/v1/products/manage/updateSpuBatch'
  return request({
    method: 'post',
    url,
    data
  })
}

// 商品导出
export const exportFile = (data) => {
  const url = '/ocean/api/v1/products/manage/exports'
  return request({
    method: 'POST',
    url: url,
    data: data
  })
}

// 导出进度查询
export const exportFileStatus = (taskId) => {
  const url = `/ocean/api/v1/products/manage/exports/${taskId}`
  return request({
    method: 'get',
    url
  })
}
// 获取定价列表
export const getPriceList = (spuId) => {
  const url = `/ocean/api/v1/product/spu/${spuId}/priceList`
  return request({
    method: 'get',
    url
  })
}
// 保存定价列表
export const putPriceList = (data) => {
  const url = `/ocean/api/v1/product/spu/${data.spuId}/prices`
  return request({
    method: 'put',
    url,
    data: data.data
  })
}
//  商品信息相关接口

// 商品发布
export const publishProd = (data) => {
  const url = '/ocean/api/v1/product/spu/batchPublish'
  return request({
    method: 'post',
    url,
    data
  })
}

// 商品spu 上下架
export const spuUpDown = (data) => {
  return request({
    method: 'put',
    url: '/ocean/api/v1/product/spu/up-down',
    data
  })
}

// spu 在售停售
export const spuSaleStatus = (data) => {
  return request({
    method: 'put',
    url: '/ocean/api/v1/product/shop/sale-status',
    data
  })
}

// sku 上下架
export const skuUpDown = (data) => {
  return request({
    method: 'put',
    url: '/ocean/api/v1/product/sku/up-down',
    data
  })
}

// 商品列表获取
export const getProductInfoList = (data) =>
  request({
    method: 'post',
    url: '/ocean/api/v1/product/spu/page',
    data
  })

// 商品编辑保存
export const productSave = (data) =>
  request({
    method: 'post',
    url: '/ocean/api/v1/product/spu/save',
    data
  })

// 商品获取
export const getProduct = (data) =>
  request({
    method: 'get',
    url: `/ocean/api/v1/product/spu/${data}`,
  })

// 类目列表接口
export const getProdCategories = (data) =>
  request({
    method: 'post',
    url: '/ocean/api/v1/product/category/page',
    data
  })

// 获取供应商列表
export const getSupplierList = (data) =>
  request({
    method: 'post',
    url: '/ocean/api/v1/product/supplier/page',
    data
  })
// 属性列表接口
export const getAttrList = (data) =>
  request({
    method: 'post',
    url: '/ocean/api/v1/product/option/list',
    data
  })
// 属性列表接口-分页
export const getAttrListPage = (data) =>
  request({
    method: 'post',
    url: '/ocean/api/v1/product/option/page',
    data
  })
// 属性编辑接口
export const updateProp = (data) =>
  request({
    method: 'put',
    url: '/ocean/api/v1/product/option/saveOrUpdate',
    data
  })
// 属性的 属性值添加或更新
export const updatePropValue = (data) =>
  request({
    method: 'put',
    url: '/ocean/api/v1/product/optionValue/saveOrUpdate',
    data
  })
// 属性的 属性值删除
export const deletePropValue = (data) =>
  request({
    method: 'delete',
    url: `/ocean/api/v1/product/optionValue/delete/${data.id}`,
  })
// 属性的 属性值列表
export const propListValue = (data) =>
  request({
    method: 'post',
    url: '/ocean/api/v1/product/optionValue/list',
    data
  })
// 删除属性
export const deleteProp = (id) =>
  request({
    method: 'delete',
    url: `/ocean/api/v1/product/option/delete/${id}`
  })
// 获取标签列表
export const getTagList = (data) =>
  request({
    method: 'post',
    url: '/ocean/api/v1/product/tag/page',
    data
  })

// 增加编辑标签
export const updateTag = (data) =>
  request({
    method: 'put',
    url: '/ocean/api/v1/product/tag/saveOrUpdate',
    data
  })

// 删除标签
export const deleteTag = (id) =>
  request({
    method: 'delete',
    url: `/ocean/api/v1/product/tag/delete/${id}`
  })

// 获取店铺列表
export const getShopList = (data) =>
  request({
    method: 'get',
    url: '/ocean/api/v1/shop/select',
    params: data
  })

// 开售和停售
export const saleStatus = (data) =>
  request({
    method: 'put',
    url: `/ocean/api/v1/product/${data.shopSpuId}/saleStatus`,
    data: { saleStatus: data.saleStatus }
  })

// 售卖管理获取列表信息
export const getSalesList = (data) =>
  request({
    method: 'get',
    url: `/ocean/api/v1/product/spu/${data.spuId}/saleList`,
    params: { published: data.published }
  })

// 获取文件上传参数
export const getUpload = (data) =>
  request({
    method: 'get',
    url: '/ocean/api/v1/common/file/upload/token',
    params: data
  })

// 文件导出

// 获取定价列表
export const priceList = (data) =>
  request({
    method: 'get',
    url: `/ocean/api/v1/product/spu/${data}/priceList`
  })

// 批量打标签确认
export const batchSetTag = (data) =>
  request({
    method: 'POST',
    url: '/ocean/api/v1/product/tag/bind',
    data
  })

// 商品标签解除绑定
export const batchRelieveTag = (data) =>
  request({
    method: 'POST',
    url: '/ocean/api/v1/product/tag/relieve',
    data
  })

// 商品导出
export const exportExcel = (data) =>
  request({
    method: 'POST',
    url: '/ocean/api/v1/product/export',
    responseType: 'blob',
    data
  })

// 批量设置供应商
export const setSupplier = (data) => {
  return request({
    method: 'POST',
    url: '/ocean/api/v1/product/setSupplier',
    data
  })
}

// 批量设置安全库存
export const batchSetSku = (data) => {
  return request({
    method: 'POST',
    url: '/ocean/api/v1/product/setSafeInventory',
    data
  })
}

// 商品导出
export const exportProducts = (data) =>
  request({
    method: 'POST',
    url: '/ocean/api/v1/export/products',
    responseType: 'blob',
    data
  })
// 商品导入
export const importProducts = (data, params) =>
  request({
    method: 'POST',
    url: '/ocean/api/v1/import/products',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data,
    params
  })
